import styled, { css } from 'styled-components';
import theme from '../theme';
import { FunctionComponent, Suspense } from 'react';
import React from 'react';

const Content: FunctionComponent<{ className?: string }> = ({ className }) => (
    <svg className={className} x='0px' y='0px' viewBox='0 0 868.5 261.6'>
        <path
            fill='#003298'
            d='M222.1,198.2c-4.7,2.1-8.2-0.2-11.1-2.7c-4.8-4.1-9.2-8.7-13.8-13c-2.7-2.5-5.4-4.9-8.8-6.5
	c-6.1-2.9-10.4-1-12.8,5.5c0.7,4.5,3.6,7.7,6.9,10.6c5.4,4.7,11,9.1,16.5,13.8c2,1.7,3.9,3.7,5.5,5.7c2.6,3.3,3.1,6.5-0.6,9.6
	c-3.6,3-7.5,3-10.7-0.3c-3.5-3.7-5.4-8.3-7.6-12.8c-2.4-5.1-4.6-10.3-8-14.9c-2-2.6-4.4-4.8-7.8-4.7c-5.7,0.2-8.5,4.7-6.4,10.1
	c1.2,3.1,2.9,6,4.4,8.9c1.2,2.3,2,4.5,1.4,7.1c-2.8,2.6-2.8,2.6-7.1,2.2c-2.6-1.9-3.6-5-4.9-7.8c-1.3-3-2.6-6.1-4.3-8.9
	c-1.7-2.9-4.6-3.9-7.8-2.9c-3,0.9-4.6,3.1-5,6.2c-0.6,5.1,0.5,9.9,1.7,14.8c2.4,9.5,6.1,18.6,6.9,28.4c0.5,6.1-1.3,9.6-5.5,11
	c-5.1,1.7-9-0.5-10-5.7c-1.7-8.4,0.4-16.5,1.6-24.7c1-7.1,2.2-14.1,1.7-21.3c-0.3-3.7-1.5-6.8-5.5-7.2c-3.8-0.4-5.7,2.3-6.6,5.6
	c-1.1,3.8-2,7.7-2.9,11.6c-0.5,2.3-1.4,4.4-3.4,6c-6.7,0.8-8.5-1.1-6.9-7.7c0.7-2.9,1.7-5.7,2.4-8.6c1-3.7,2.5-7.8-0.8-10.8
	c-3.6-3.3-8.3-5-13.4-3.7c-1.9,0.5-3.7,1.3-5.6,2.1c-1.2-1.5,0.4-2.8,0.7-4c0.9-3,1-5.9-0.2-8.8c-1-2.6-1.8-5.7-5-6.3
	c-3.4-0.7-4.9,2.3-6.7,4.4c-3.4,4.3-6,9.2-10,13c-2.8,2.6-5.8,3.9-9.4,1.3c-4.6-3.3-4.6-7.4,0.4-10.1c4-2.3,8.4-3.9,12.5-6.1
	c3.4-1.8,7.4-3.6,6.9-8.2c-0.5-4.4-3.4-7.5-7.6-9c-8,1.5-11.1,10-18,12.6c-2.7-0.9-2.7-3-3.3-4.6c0.8-3.7,3.3-5.2,6.1-6.4
	c3.8-1.6,7.7-3,11.4-4.8c5.5-2.7,7.3-6.2,6.3-11.1c-1.1-5.1-4.6-7.8-10.6-7.9c-9.3-0.3-17.9,3.2-26.8,5.3c-4.7,1.1-9.3,2.3-14.1,3.3
	c-6.1,1.2-10-0.9-10.3-5.4c-0.4-4.8,3-7.8,9.2-8.2c9.9-0.6,19.5,1.6,29.3,2.6c4.8,0.5,9.6,0.7,14.4-0.5c5.7-1.4,8.3-4.3,9-10.5
	c-1.9-3.3-5.5-3.9-8.9-4.6c-11.6-2.4-23.5-2.2-35.1-4c-4.3-0.7-8.9-0.8-12-4.6c0.9-3.9,3.6-4.4,6.5-4.4c9.4,0.2,18.2,3.5,27.3,5.4
	c5,1.1,10,2.5,15.2,2.5c2.9,0,5.9-0.1,7.1-3.4c1.3-3.3-0.5-5.9-2.9-7.8c-3.8-3-7.9-5.5-11.7-8.5c-4.4-3.5-4.4-5.6-1-10
	c2.9-1.2,5.5-0.3,7.9,1.4c2.5,1.7,4.9,3.4,7.6,4.8c5.4,3,8.2,1.9,11-4.1c-0.7-5.3-5.3-8.1-8.2-12c-3.4-4.5-2.8-6.9,2.8-9.4
	c3.6,0.5,5.6,3.2,7.7,5.7c2.3,2.8,4.4,5.8,6.8,8.6c2.1,2.5,4.7,4.9,8.1,3.3c3.7-1.7,5.9-4.8,5.9-9.1c0-4-1.6-7.4-3.4-10.8
	c-3.6-6.8-8.5-12.7-12.9-18.9c-2.7-3.8-5.4-7.6-7-12c-1.4-4-0.9-7.2,3.3-9.1c4.3-2,7.9-1,10.2,3.1c3.1,5.6,3.7,12,4.8,18.2
	c1.3,6.8,2.2,13.8,5.2,20.1c3.5,7.1,9.3,9.3,16.2,6.1c3.7-7.8-4.7-15.7-1.1-23.5c2.2-1.2,4-1,5.9-0.4c2.8,2.9,1.9,6.5,1.4,9.9
	c-0.5,3.2-0.8,6.3-0.6,9.4c0.2,2.7,1.5,4.8,4.4,5.4c2.9,0.5,5.1-0.5,6.6-3.3c2.1-4,2.4-8.6,3.8-12.8c1-3.1,2-6.4,6.2-5.7
	c4.5,0.8,4.6,4.5,3.9,7.9c-0.9,5-2.5,10-3.6,15c-0.9,4.2,0,7.7,4.8,8.9c3.7-0.5,5.8-3.1,7.6-5.9c2.6-4.1,4.9-8.3,7.5-12.4
	c1.5-2.4,3.2-4.7,6.3-5.4c5.3,1.6,6.6,3.8,4.2,8.7c-2.7,5.5-6.1,10.6-9,16c-1.7,3.2-2.7,6.6,0.9,9.7c3.4,1.5,5.6-0.9,7.5-3
	c4.6-5.1,8.8-10.4,13.2-15.6c2.6-3.1,5.3-6,8.6-8.3c4.9-3.4,9.5-2.8,12.7,1.5c2.8,3.9,1.9,7.8-3,11.5c-4.5,3.4-9.8,5.6-14.8,8.2
	c-3.1,1.6-6.2,3.2-9.1,5c-2.4,1.5-5.2,3.3-3.5,6.7c1.6,3.2,4.7,4.9,8.3,4c3-0.7,5.9-2.2,8.8-3.3c1.9-0.7,3.6-1.8,6.4-0.8
	c2.3,1.3,2.9,3.8,2.2,6.9c-1.6,2.6-4.3,3.6-6.9,4.6c-3.2,1.3-6.6,2.4-9.7,3.8c-3.4,1.5-6,3.8-4.8,8.1c1.4,5.3,4.1,7.4,9.2,7.2
	c4-0.1,7.4-1.9,10.8-3.5c5.6-2.6,10.7-6,16.6-7.9c6.1-2,8.7-0.4,9.9,5.8c0.1,0.7,0.1,1.3,0.2,2c0.6,8.8-1.3,10.8-10,10.6
	c-6-0.1-11.9-1.7-17.9-1.2c-3.8,0.3-7.2,1.5-9.8,4.2c-3.9,4.1-3.4,8.2,1.6,11c6,3.4,12.8,4.3,19.5,5.8c5.8,1.3,11.7,2.5,17.4,4
	c2.6,0.7,5.1,1.7,6.1,4.4c-1.9,5.6-3.6,6.5-8.8,4.9c-7-2.2-13-6.6-19.4-10.1c-4.5-2.4-9-4.9-14.3-5.7c-4.7-0.7-8.1,1.2-10.2,5.4
	c-0.4,0.9-0.7,1.9-1.2,2.8c-4,7.3-3.7,9.7,3.3,14.6c7.1,4.9,14.6,9.3,21.7,14.1C221.4,191.4,223.6,194,222.1,198.2z'
        />
        <path
            fill='#003298'
            d='M608.7,101.2c5.8,0,11.2,0,17,0c5.4,14.3,11.4,28.4,16,43.6c5.6-14.8,11.1-29.2,16.5-43.6
	c5.8,0,11.2,0,17.1,0c2.3,22.3,4.6,44.5,7,67c-5.1,0-9.9,0-15.1,0c-2-14.5-2.7-29-4.7-43.7c-5.4,14.5-10.8,29-16.2,43.4
	c-3.1,0-5.9,0-9.1,0c-5.2-14.2-10.3-28.5-15.7-43.2c-1.1,14.8-2.2,29-3.3,43.5c-5,0-9.7,0-15.3,0C604.9,146,606.8,123.9,608.7,101.2
	z'
        />
        <path
            fill='#003398'
            d='M530,134.9c0.1-18.2,8.9-31,24.4-34.1c26.9-5.4,41.1,12.4,41.1,32c0,5.9-0.3,11.6-2.5,17.1
	c-5.6,14.2-19.9,21.6-36.7,19.1c-14.3-2.1-25.1-14.2-26-29.2C530.2,138,530.1,136.2,530,134.9z'
        />
        <path
            fill='#33CB33'
            d='M795.3,155.1c-7.8,0-15.4,0-23.4,0c-2.4,3.8-2.3,8.8-4.7,13.1c-5,0-10.1,0-15.6,0
	c7.5-22.4,14.8-44.6,22.2-66.9c6.5,0,12.9,0,19.7,0c7.4,22.1,14.7,44.3,22.2,66.9c-5.6,0-10.7,0-16.2,0
	C798.1,163.9,796.7,159.6,795.3,155.1z'
        />
        <path
            fill='#003298'
            d='M402.4,101.2c5.1,0,9.7,0,14.4,0c1.2,1.2,0.6,2.8,0.6,4.2c0,13.5,0.2,27-0.1,40.5
	c-0.3,12.4-8.9,21.8-20.5,23.3c-16.8,2.2-28.6-3.6-32.6-16c-0.7-2.2-1.4-4.5-1.4-6.8c-0.1-14.9-0.1-29.9-0.1-45.1c5,0,9.8,0,15.2,0
	c0,4.8-0.1,9.6,0,14.4c0.2,10.1-0.7,20.3,0.5,30.4c0.7,6.4,4.5,9.5,11.1,9.7c6.6,0.3,10.5-2.6,12.2-8.6c0.8-2.8,0.7-5.6,0.7-8.4
	C402.4,126.3,402.4,113.8,402.4,101.2z'
        />
        <path
            fill='#013298'
            d='M428.5,165.1c0-5,0-9.6,0-14.8c6,3.3,11.9,6.3,18.8,6c3.8-0.2,7-0.8,8.3-4.9c1.3-4.4-1.6-6.5-4.8-8.2
	c-3.8-2-7.8-3.6-11.6-5.7c-9-4.9-12.8-12.2-11.1-20.8c1.8-9.1,7.9-14.3,18-15.8c7.9-1.2,15.5-0.2,23.1,2.8c0,4.6,0,9.1,0,13.9
	c-4.7-1.7-9.3-3.7-14.4-4.2c-2.1-0.2-4,0.1-5.9,0.6c-2.2,0.6-3.9,2-4.4,4.3c-0.5,2.4,0.7,4.4,2.6,5.5c3.7,2.2,7.6,4.1,11.4,6
	c5.5,2.8,10.4,6,12.6,12.1c3.9,10.6-1.2,21.4-12,25.5C450.8,170.7,436.9,169.7,428.5,165.1z'
        />
        <path
            fill='#003398'
            d='M351.3,103.8c0,4.6,0,9.2,0,14.1c-11.6-4.5-23.1-7.7-32,4.3c-5.5,7.4-4.9,19.5,0.6,26.2
	c6.7,8.1,16.3,9,31.3,3.1c0,4.8,0,9.6,0,14.2c-10.7,6.1-33.3,5.8-44.7-8.6c-9.7-12.2-9.8-33.1,0.2-45C317,99.8,337.4,96,351.3,103.8
	z'
        />
        <path
            fill='#32CB32'
            d='M743.4,151.6c0,4.7,0,9.3,0,13.9c-12.4,7.8-33,4.4-43.5-7.1c-10.9-11.9-11.5-32.9-1.4-45.7
	c10-12.7,30.6-16.9,44.9-9c0,4.5,0,9.2,0,14.1c-11.5-4.4-23-7.6-31.9,4.4c-5.1,6.9-4.8,18.9,0.1,25.4
	C717.8,156.2,726.5,157.3,743.4,151.6z'
        />
        <path
            fill='#33CB33'
            d='M831.8,113.1c-5.8,0-10.8,0-16,0c-1-3.9-0.4-7.7-0.5-11.8c15.9,0,31.6,0,47.7,0c1.1,3.5,0.2,7.2,0.5,11.6
	c-5.3,0-10.5,0-16.2,0c0,18.7,0,36.8,0,55.1c-5.3,0-10.2,0-15.6,0C831.8,149.9,831.8,131.8,831.8,113.1z'
        />
        <path
            fill='#003398'
            d='M495.2,168.1c0-18.4,0-36.4,0-54.9c-5.7,0-10.9,0-16.5,0c0-4.1,0-7.9,0-11.9c15.9,0,31.8,0,48,0
	c0,3.8,0,7.5,0,11.8c-5.3,0-10.6,0-16.2,0c0,18.6,0,36.7,0,55.1C505.4,168.1,500.7,168.1,495.2,168.1z'
        />
        <path
            fill='#013398'
            d='M88.8,199.4c-3.8,11.1-7.1,20.7-10.4,30.4c-0.8,2.4-2,4.6-3.6,6.5c-3.4,4-7.9,4-12.8,0.1
	c-4.2-3.2-4.6-6.2-1.6-10.8c1.9-2.8,4.3-5.1,6.8-7.3C74.1,212.4,81.4,206.9,88.8,199.4z'
        />
        <path
            fill='#013399'
            d='M227.9,142.1c12.4-1.7,23.7-3.4,35.1-0.6c4.1,1,7,3.3,5.1,8.4c-3.1,3.5-7.4,2.6-11.1,2
	C247.2,150.3,237.9,146.8,227.9,142.1z'
        />
        <path
            fill='#013398'
            d='M162.4,43.1c1.3-9.6,2.3-19.2,5.9-28.1c1-2.5,2.1-4.9,3.9-6.9c1.7-1.8,3.8-2.9,6.2-1.5
	c2.3,1.3,2.9,3.3,2.5,5.9c-0.9,5.9-3.9,10.9-7,15.8C170.5,33.6,167.2,38.9,162.4,43.1z'
        />
        <path
            fill='#013398'
            d='M44.3,180.4c-7.4,6.5-15.2,12.1-24,16.1c-2.8,1.2-5.6,2-8.6,1.9c-2-0.1-3.5-0.8-4.3-2.8
	c-0.8-2.1-0.4-3.9,1.2-5.4c1.1-1,2.3-2,3.6-2.6C22.4,182.7,33.3,181.4,44.3,180.4z'
        />
        <path
            fill='#053599'
            d='M11,111.3c-3-0.1-4.7-1.9-4.7-5c0-3.2,1.8-5,4.8-5.1c3.3,0,5.3,1.9,5.2,5.3C16.2,109.6,14.4,111.2,11,111.3z
	'
        />
        <path fill='#033599' d='M219.3,98c0.2-3.4,1.9-5.1,5.1-5c3.1,0,5,1.7,5,4.9c0,3.4-2,5.3-5.3,5.2C220.9,102.9,219.4,100.8,219.3,98z' />
        <path
            fill='#FEFEFE'
            d='M161.5,149.6c5.9,3.4,11.6,6.8,17.3,10.1c-7.1,15.9-30.3,26.2-49.4,22.2c-21.6-4.5-37.6-23.2-38.4-45
	c-0.9-22.5,13.5-42.5,34.7-48.5c20.4-5.7,43.5,3.3,53.3,21.2c-5.8,3.4-11.6,6.7-17.3,10.1c-15.4-14.1-31.1-15.4-42.2-3.6
	c-10.2,10.8-9.8,27.9,0.9,38.2C132,165.2,148,163.6,161.5,149.6z'
        />
        <path
            fill='#FEFEFE'
            d='M546.4,134.9c-0.2-4.9,0.7-9.1,2.8-13c2.9-5.2,7.2-7.9,13.3-8.1c6.1-0.1,10.8,2.2,13.6,7.5
	c4.6,8.6,4.6,17.6,0.1,26.3c-3,5.7-8.1,8-14.5,7.6s-10.5-3.8-13.1-9.3C546.9,142.4,546,138.5,546.4,134.9z'
        />
        <path fill='#FDFEFD' d='M783.5,113.2c2.9,10.4,5.3,19.3,7.9,28.7c-5.3,0.9-10.5,0.3-16,0.4C778,132.7,780.6,123.6,783.5,113.2z' />
    </svg>
);

const CustomCatLogo = styled(Content)`
    width: 180px;
    height: 180px;
`;

export default CustomCatLogo;
